import { ErrorBoundary } from 'react-error-boundary'
import { useRouter } from 'next/router'

import { isToggleEnabled } from 'configs/toggle-feature'
import InfoTerkiniDetailApp from 'app/InfoTerkiniDetailPage/pages/InfoTerkiniDetail'
import { CustomErrorFallback } from 'components/ErrorBoundary'

export async function getServerSideProps({ params }) {
  const isRuangGtkEnabled = await isToggleEnabled('ruang-gtk-enabled')

  return {
    props: {
      id: params.id,
      isRuangGtkEnabled,
    },
  }
}

export interface InfoTerkiniDetailProps {
  id: string
  isRuangGtkEnabled: boolean
}

const InfoTerkiniDetailPage = (props: InfoTerkiniDetailProps) => {
  const router = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      FallbackComponent={({ error, resetErrorBoundary }) => {
        return (
          <CustomErrorFallback
            error={error}
            resetErrorBoundary={resetErrorBoundary}
          />
        )
      }}
    >
      <InfoTerkiniDetailApp {...props} />
    </ErrorBoundary>
  )
}

// eslint-disable-next-line react/display-name
InfoTerkiniDetailPage.Layout = ({ children }) => (
  <div className="bg-surface-subdued min-h-screen">{children}</div>
)

export default InfoTerkiniDetailPage
